import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import '../styles/Login.css';

export default function VerifyEmailPage({ setUser, setToken }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tokenFromUrl = searchParams.get('token');

  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  // Manual code entry fallback
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [manualLoading, setManualLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendNotice, setResendNotice] = useState('');

  useEffect(() => {
    if (tokenFromUrl) {
      setVerifying(true);
      setError('');
      axios.post('/api/auth/verify-email', { token: tokenFromUrl })
        .then(res => {
          setSuccess(true);
          const { token, user } = res.data;
          if (token && user) {
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            if (setToken) setToken(token);
            if (setUser) setUser(user);
          }
          setTimeout(() => {
            navigate('/');
          }, 2000);
        })
        .catch(err => {
          setError(err.response?.data?.error || 'Tasdiqlaş havolasi yaroqsiz yoki muddati õtgan.');
        })
        .finally(() => {
          setVerifying(false);
        });
    }
  }, [tokenFromUrl, navigate, setToken, setUser]);

  const handleManualVerify = async (e) => {
    e.preventDefault();
    if (!email.trim() || !code.trim()) {
      setError('Iltimos, emailingizni va 6 xonali tasdiqlaş kodini kiriting.');
      return;
    }

    try {
      setManualLoading(true);
      setError('');
      const res = await axios.post('/api/auth/verify-email', {
        email: email.trim().toLowerCase(),
        code: code.trim()
      });

      setSuccess(true);
      const { token, user } = res.data;
      if (token && user) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        if (setToken) setToken(token);
        if (setUser) setUser(user);
      }
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Kiritilgan kod nõtõğri yoki muddati tugagan.');
    } finally {
      setManualLoading(false);
    }
  };

  const handleResend = async () => {
    if (!email.trim()) {
      setError('Tasdiqlaş xatini qayta yuboriş ucun emailingizni kiriting.');
      return;
    }
    try {
      setResending(true);
      setError('');
      setResendNotice('');
      const res = await axios.post('/api/auth/resend-verification', { email: email.trim().toLowerCase() });
      setResendNotice(res.data.message || 'Yangi tasdiqlaş xati emailingizga yuborildi!');
    } catch (err) {
      setError(err.response?.data?.error || 'Xat yuborişda xatolik yuz berdi.');
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-card-container">
        <div className="university-brand-header" onClick={() => navigate('/')} title="Boş sahifaga õtiş">
          <img src="/logo.png" alt="Turon University" className="turon-auth-logo" />
        </div>

        <div className="auth-box-card">
          <h2 className="auth-card-title">Hisobni faollaştiriş</h2>

          {verifying && (
            <div style={{ textAlign: 'center', padding: '30px 10px' }}>
              <div className="spinner" style={{ margin: '0 auto 16px auto', width: '38px', height: '38px', border: '3px solid #e2e8f0', borderTop: '3px solid #1e40af', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }}></div>
              <p style={{ fontSize: '15px', color: '#475569', fontWeight: '600' }}>Elektron poçtangiz tasdiqlanmoqda...</p>
            </div>
          )}

          {success && (
            <div style={{ textAlign: 'center', padding: '24px 10px' }}>
              <div style={{ fontSize: '48px', color: '#16a34a', marginBottom: '12px' }}>✓</div>
              <h3 style={{ color: '#15803d', margin: '0 0 10px 0', fontSize: '20px' }}>Elektron poçta tasdiqlandi!</h3>
              <p style={{ fontSize: '14px', color: '#475569', lineHeight: '1.6', margin: '0 0 20px 0' }}>
                Hisobingiz muvaffaqiyatli faollaştirildi. Bir neça soniyada şaxsiy kabinetga yõnaltirilasiz...
              </p>
              <button
                type="button"
                className="btn-main-submit"
                onClick={() => navigate('/')}
              >
                Boş sahifaga õtiş →
              </button>
            </div>
          )}

          {!verifying && !success && (
            <div>
              {error && (
                <div className="auth-alert-error">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                  <span>{error}</span>
                </div>
              )}

              {resendNotice && (
                <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#15803d', padding: '12px', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', fontWeight: '500' }}>
                  ✓ {resendNotice}
                </div>
              )}

              <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.6', marginBottom: '20px' }}>
                Poçtangizga yuborilgan tasdiqlaş xatidagi 6 xonali kodni kiriting yoki xat içidagi faollaştiriş havolasini bosing:
              </p>

              <form onSubmit={handleManualVerify} className="auth-login-form">
                <div className="input-field-group">
                  <label htmlFor="verify-email">Elektron poçta manzilingiz</label>
                  <input
                    id="verify-email"
                    type="email"
                    placeholder="masalan: student@turon.uz"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="input-field-group">
                  <label htmlFor="verify-code">6 xonali tasdiqlaş kodi</label>
                  <input
                    id="verify-code"
                    type="text"
                    maxLength={6}
                    placeholder="123456"
                    value={code}
                    onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                    style={{ letterSpacing: '6px', fontSize: '18px', textAlign: 'center', fontWeight: '700' }}
                    required
                  />
                </div>

                <button type="submit" className="btn-main-submit" disabled={manualLoading}>
                  {manualLoading ? 'Tekşirilmoqda...' : 'Tasdiqlaş va kiriş'}
                </button>
              </form>

              <div style={{ marginTop: '20px', textAlign: 'center', borderTop: '1px solid #f1f5f9', paddingTop: '16px' }}>
                <button
                  type="button"
                  onClick={handleResend}
                  disabled={resending}
                  style={{ background: 'none', border: 'none', color: '#2563eb', fontSize: '13px', fontWeight: '600', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  {resending ? 'Yuborilmoqda...' : 'Tasdiqlaş xatini qayta yuboriş'}
                </button>
              </div>
            </div>
          )}
        </div>

        <div className="auth-footer-prompt">
          <span>Hisobingiz allaqaçon tasdiqlanganmi? </span>
          <Link to="/login" className="register-now-link">Kiriş</Link>
        </div>
      </div>
    </div>
  );
}
